import { buildModelManager } from "../builder.js";
const DefaultFormSubmissionSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  discrepancyNotificationSent: true,
  encounterSummary: true,
  fisdapCrossCheckResult: true,
  fisdapDiscrepancies: true,
  formData: true,
  institution: true,
  institutionFormId: true,
  phiDetails: true,
  phiDetected: true,
  reviewNotes: true,
  reviewedById: true,
  shiftDocumentationId: true,
  shiftId: true,
  signatureData: true,
  status: true,
  studentId: true,
  submissionType: true,
  submittedAt: true,
  submitterDeviceInfo: true,
  submitterIpAddress: true,
  submitterLatitude: true,
  submitterLongitude: true,
  updatedAt: true,
  uploadedFile: { url: true, mimeType: true, fileName: true },
  varianceNotificationSent: true,
  variances: true
};
const modelApiIdentifier = "formSubmission";
const pluralModelApiIdentifier = "formSubmissions";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFormSubmissionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createFormSubmission",
    operationReturnType: "CreateFormSubmission",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      formSubmission: { required: false, type: "CreateFormSubmissionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateFormSubmissions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateFormSubmissionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "action",
    operationName: "updateFormSubmission",
    operationReturnType: "UpdateFormSubmission",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      formSubmission: { required: false, type: "UpdateFormSubmissionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateFormSubmissions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateFormSubmissionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "action",
    operationName: "deleteFormSubmission",
    operationReturnType: "DeleteFormSubmission",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteFormSubmissions",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertFormSubmission",
    operationReturnType: "UpsertFormSubmission",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      formSubmission: { required: false, type: "UpsertFormSubmissionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateFormSubmissionResult": { hasReturnType: false },
      "... on UpdateFormSubmissionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertFormSubmissions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertFormSubmissionsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultFormSubmissionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "formSubmissionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const FormSubmissionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultFormSubmissionSelection,
  operations
);
export {
  DefaultFormSubmissionSelection,
  FormSubmissionManager
};
//# sourceMappingURL=FormSubmission.js.map
